import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/HomeView.vue')
  },
  {
    path: '/auth',
    name: 'Authentication',
    component: () => import('@/views/LoginView.vue')
  },
  {
    path: '/navbar',
    name: 'Navbar',
    component: () => import('@/views/List_Navbars.vue')
  },
  {
    path: '/categories',
    name: 'Categorias',
    component: () => import('@/views/List_Categories.vue')
  },
  {
    path: '/posts',
    name: 'Posts',
    component: () => import('@/views/List_Posts.vue')
  },
  {
    path: '/profile/account',
    name: 'Profile',
    component: () => import('@/views/ProfileView.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'Error 404',
    component: () => import('@/views/Error404.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  document.title = `${to.name} | ${process.env.VUE_APP_PROJECT}`
  window.scrollTo(0, 0);
  next()
})

export default router
